import React, { Suspense } from "react";

const Footer = React.lazy(() => import("../Footer"));
const Menu = React.lazy(() => import("../Menu"));

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <>
      {children}
      <Suspense fallback={null}>
        <Footer />
        <Menu />
      </Suspense>
    </>
  );
};

export default MainLayout;
